export const countryOptions = [
  { name: "Afghanistan", code: "+93", flag: "af" },
  { name: "Albania", code: "+355", flag: "al" },
  { name: "Algeria", code: "+213", flag: "dz" },
  { name: "Andorra", code: "+376", flag: "ad" },
  { name: "Angola", code: "+244", flag: "ao" },
  { name: "Argentina", code: "+54", flag: "ar" },
  { name: "Armenia", code: "+374", flag: "am" },
  { name: "Australia", code: "+61", flag: "au" },
  { name: "Austria", code: "+43", flag: "at" },
  { name: "Azerbaijan", code: "+994", flag: "az" },
  { name: "Bahamas", code: "+1242", flag: "bs" },
  { name: "Bahrain", code: "+973", flag: "bh" },
  { name: "Bangladesh", code: "+880", flag: "bd" },
  { name: "Barbados", code: "+1246", flag: "bb" },
  { name: "Belarus", code: "+375", flag: "by" },
  { name: "Belgium", code: "+32", flag: "be" },
  { name: "Belize", code: "+501", flag: "bz" },
  { name: "Benin", code: "+229", flag: "bj" },
  { name: "Bhutan", code: "+975", flag: "bt" },
  { name: "Bolivia", code: "+591", flag: "bo" },
  { name: "Botswana", code: "+267", flag: "bw" },
  { name: "Brazil", code: "+55", flag: "br" },
  { name: "Brunei", code: "+673", flag: "bn" },
  { name: "Bulgaria", code: "+359", flag: "bg" },
  { name: "Burkina Faso", code: "+226", flag: "bf" },
  { name: "Burundi", code: "+257", flag: "bi" },
  { name: "Cambodia", code: "+855", flag: "kh" },
  { name: "Cameroon", code: "+237", flag: "cm" },
  { name: "Canada", code: "+1", flag: "ca" },
  { name: "Cape Verde", code: "+238", flag: "cv" },
  { name: "Central African Republic", code: "+236", flag: "cf" },
  { name: "Chad", code: "+235", flag: "td" },
  { name: "Chile", code: "+56", flag: "cl" },
  { name: "China", code: "+86", flag: "cn" },
  { name: "Colombia", code: "+57", flag: "co" },
  { name: "Comoros", code: "+269", flag: "km" },
  { name: "Congo", code: "+242", flag: "cg" },
  { name: "Costa Rica", code: "+506", flag: "cr" },
  { name: "Côte d'Ivoire", code: "+225", flag: "ci" },
  { name: "Croatia", code: "+385", flag: "hr" },
  { name: "Cuba", code: "+53", flag: "cu" },
  { name: "Cyprus", code: "+357", flag: "cy" },
  { name: "Denmark", code: "+45", flag: "dk" },
  { name: "Djibouti", code: "+253", flag: "dj" },
  { name: "Dominica", code: "+1767", flag: "dm" },
  { name: "Dominican Republic", code: "+1809", flag: "do" },
  { name: "Ecuador", code: "+593", flag: "ec" },
  { name: "Egypt", code: "+20", flag: "eg" },
  { name: "El Salvador", code: "+503", flag: "sv" },
  { name: "Equatorial Guinea", code: "+240", flag: "gq" },
  { name: "Eritrea", code: "+291", flag: "er" },
  { name: "Estonia", code: "+372", flag: "ee" },
  { name: "Ethiopia", code: "+251", flag: "et" },
  { name: "Fiji", code: "+679", flag: "fj" },
  { name: "Finland", code: "+358", flag: "fi" },
  { name: "France", code: "+33", flag: "fr" },
  { name: "Gabon", code: "+241", flag: "ga" },
  { name: "Gambia", code: "+220", flag: "gm" },
  { name: "Georgia", code: "+995", flag: "ge" },
  { name: "Germany", code: "+49", flag: "de" },
  { name: "Ghana", code: "+233", flag: "gh" },
  { name: "Greece", code: "+30", flag: "gr" },
  { name: "Grenada", code: "+1473", flag: "gd" },
  { name: "Guatemala", code: "+502", flag: "gt" },
  { name: "Guinea", code: "+224", flag: "gn" },
  { name: "Guinea-Bissau", code: "+245", flag: "gw" },
  { name: "Guyana", code: "+592", flag: "gy" },
  { name: "Haiti", code: "+509", flag: "ht" },
  { name: "Honduras", code: "+504", flag: "hn" },
  { name: "Hungary", code: "+36", flag: "hu" },
  { name: "Iceland", code: "+354", flag: "is" },
  { name: "India", code: "+91", flag: "in" },
  { name: "Indonesia", code: "+62", flag: "id" },
  { name: "Iran", code: "+98", flag: "ir" },
  { name: "Iraq", code: "+964", flag: "iq" },
  { name: "Ireland", code: "+353", flag: "ie" },
  { name: "Israel", code: "+972", flag: "il" },
  { name: "Italy", code: "+39", flag: "it" },
  { name: "Jamaica", code: "+1876", flag: "jm" },
  { name: "Japan", code: "+81", flag: "jp" },
  { name: "Jordan", code: "+962", flag: "jo" },
  { name: "Kazakhstan", code: "+7", flag: "kz" },
  { name: "Kenya", code: "+254", flag: "ke" },
  { name: "Kiribati", code: "+686", flag: "ki" },
  { name: "North Korea", code: "+850", flag: "kp" },
  { name: "South Korea", code: "+82", flag: "kr" },
  { name: "Kuwait", code: "+965", flag: "kw" },
  { name: "Kyrgyzstan", code: "+996", flag: "kg" },
  { name: "Laos", code: "+856", flag: "la" },
  { name: "Latvia", code: "+371", flag: "lv" },
  { name: "Lebanon", code: "+961", flag: "lb" },
  { name: "Lesotho", code: "+266", flag: "ls" },
  { name: "Liberia", code: "+231", flag: "lr" },
  { name: "Libya", code: "+218", flag: "ly" },
  { name: "Liechtenstein", code: "+423", flag: "li" },
  { name: "Lithuania", code: "+370", flag: "lt" },
  { name: "Luxembourg", code: "+352", flag: "lu" },
  { name: "Madagascar", code: "+261", flag: "mg" },
  { name: "Malawi", code: "+265", flag: "mw" },
  { name: "Malaysia", code: "+60", flag: "my" },
  { name: "Maldives", code: "+960", flag: "mv" },
  { name: "Mali", code: "+223", flag: "ml" },
  { name: "Malta", code: "+356", flag: "mt" },
  { name: "Marshall Islands", code: "+692", flag: "mh" },
  { name: "Mauritania", code: "+222", flag: "mr" },
  { name: "Mauritius", code: "+230", flag: "mu" },
  { name: "Mexico", code: "+52", flag: "mx" },
  { name: "Micronesia", code: "+691", flag: "fm" },
  { name: "Moldova", code: "+373", flag: "md" },
  { name: "Monaco", code: "+377", flag: "mc" },
  { name: "Mongolia", code: "+976", flag: "mn" },
  { name: "Montenegro", code: "+382", flag: "me" },
  { name: "Morocco", code: "+212", flag: "ma" },
  { name: "Mozambique", code: "+258", flag: "mz" },
  { name: "Myanmar", code: "+95", flag: "mm" },
  { name: "Namibia", code: "+264", flag: "na" },
  { name: "Nauru", code: "+674", flag: "nr" },
  { name: "Nepal", code: "+977", flag: "np" },
  { name: "Netherlands", code: "+31", flag: "nl" },
  { name: "New Zealand", code: "+64", flag: "nz" },
  { name: "Nicaragua", code: "+505", flag: "ni" },
  { name: "Niger", code: "+227", flag: "ne" },
  { name: "Nigeria", code: "+234", flag: "ng" },
  { name: "Norway", code: "+47", flag: "no" },
  { name: "Oman", code: "+968", flag: "om" },
  { name: "Pakistan", code: "+92", flag: "pk" },
  { name: "Palau", code: "+680", flag: "pw" },
  { name: "Panama", code: "+507", flag: "pa" },
  { name: "Papua New Guinea", code: "+675", flag: "pg" },
  { name: "Paraguay", code: "+595", flag: "py" },
  { name: "Peru", code: "+51", flag: "pe" },
  { name: "Philippines", code: "+63", flag: "ph" },
  { name: "Poland", code: "+48", flag: "pl" },
  { name: "Portugal", code: "+351", flag: "pt" },
  { name: "Qatar", code: "+974", flag: "qa" },
  { name: "Romania", code: "+40", flag: "ro" },
  { name: "Russia", code: "+7", flag: "ru" },
  { name: "Rwanda", code: "+250", flag: "rw" },
  { name: "Saint Lucia", code: "+1758", flag: "lc" },
  { name: "Samoa", code: "+685", flag: "ws" },
  { name: "San Marino", code: "+378", flag: "sm" },
  { name: "Saudi Arabia", code: "+966", flag: "sa" },
  { name: "Senegal", code: "+221", flag: "sn" },
  { name: "Serbia", code: "+381", flag: "rs" },
  { name: "Seychelles", code: "+248", flag: "sc" },
  { name: "Sierra Leone", code: "+232", flag: "sl" },
  { name: "Singapore", code: "+65", flag: "sg" },
  { name: "Slovakia", code: "+421", flag: "sk" },
  { name: "Slovenia", code: "+386", flag: "si" },
  { name: "Solomon Islands", code: "+677", flag: "sb" },
  { name: "Somalia", code: "+252", flag: "so" },
  { name: "South Africa", code: "+27", flag: "za" },
  { name: "South Sudan", code: "+211", flag: "ss" },
  { name: "Spain", code: "+34", flag: "es" },
  { name: "Sri Lanka", code: "+94", flag: "lk" },
  { name: "Sudan", code: "+249", flag: "sd" },
  { name: "Suriname", code: "+597", flag: "sr" },
  { name: "Sweden", code: "+46", flag: "se" },
  { name: "Switzerland", code: "+41", flag: "ch" },
  { name: "Syria", code: "+963", flag: "sy" },
  { name: "Taiwan", code: "+886", flag: "tw" },
  { name: "Tajikistan", code: "+992", flag: "tj" },
  { name: "Tanzania", code: "+255", flag: "tz" },
  { name: "Thailand", code: "+66", flag: "th" },
  { name: "Togo", code: "+228", flag: "tg" },
  { name: "Tonga", code: "+676", flag: "to" },
  { name: "Tunisia", code: "+216", flag: "tn" },
  { name: "Turkey", code: "+90", flag: "tr" },
  { name: "Turkmenistan", code: "+993", flag: "tm" },
  { name: "Tuvalu", code: "+688", flag: "tv" },
  { name: "Uganda", code: "+256", flag: "ug" },
  { name: "Ukraine", code: "+380", flag: "ua" },
  { name: "United Arab Emirates", code: "+971", flag: "ae" },
  { name: "United Kingdom", code: "+44", flag: "gb" },
  { name: "United States", code: "+1", flag: "us" },
  { name: "Uruguay", code: "+598", flag: "uy" },
  { name: "Uzbekistan", code: "+998", flag: "uz" },
  { name: "Vanuatu", code: "+678", flag: "vu" },
  { name: "Vatican City", code: "+379", flag: "va" },
  { name: "Venezuela", code: "+58", flag: "ve" },
  { name: "Vietnam", code: "+84", flag: "vn" },
  { name: "Yemen", code: "+967", flag: "ye" },
  { name: "Zambia", code: "+260", flag: "zm" },
  { name: "Zimbabwe", code: "+263", flag: "zw" },
  { name: "Palestine", code: "+970", flag: "ps" },
  { name: "Timor-Leste", code: "+670", flag: "tl" },
  { name: "Abkhazia", code: "+995", flag: "ge" },
  { name: "Hong Kong", code: "+852", flag: "hk" },
  { name: "Macau", code: "+853", flag: "mo" },
  { name: "Faroe Islands", code: "+298", flag: "fo" },
  { name: "Greenland", code: "+299", flag: "gl" },
  { name: "Gibraltar", code: "+350", flag: "gi" },
  { name: "Antigua and Barbuda", code: "+1268", flag: "ag" },
  { name: "Saint Kitts and Nevis", code: "+1869", flag: "kn" },
  { name: "Saint Vincent and the Grenadines", code: "+1784", flag: "vc" },
  { name: "Trinidad and Tobago", code: "+1868", flag: "tt" },
];
